export const getBasePath = () => {
  return process.env.__NEXT_ROUTER_BASEPATH ?? "";
};
